import { Content } from "antd/lib/layout/layout";
import React from "react";
import CurrentCycle from "../../components/home/CurrentCycle";

function Home() {
  const proHeight = document.body.clientHeight;

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <div
          style={{
            height: proHeight - 64,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          <CurrentCycle />
        </div>
      </Content>
    </>
  );
}

export default Home;
